import { FC } from 'react';
import { IconButton } from '../iconButton';
import ContainerElementRight from 'shared/assets/icons/arrow-right.svg';

interface ArrowRightIconButtonProps {
	onClick: () => void;
}

export const ArrowRightIconButton: FC<ArrowRightIconButtonProps> = ({
	onClick,
}) => {
	return (
		<IconButton
			role="arrow-right-button"
			iconSrc={ContainerElementRight}
			onClick={onClick}
			styles={{ height: '64px' }}
		/>
	);
};
